import { FC } from 'react';
import { NavLink } from 'react-router';
import { Logo } from '@/components/Logo';
import { Role } from '@/models/auth';
import { Balance } from './Balance';
import { routes } from '@/features/navigation/constants';
import { SidebarButton } from '@/features/sidebar/SidebarButton';
import { cx } from '@emotion/css';
import { Trans } from 'react-i18next';

export const Sidebar: FC<{
  role: Role;
}> = ({ role }) => {
  return (
    <nav className="h-full px-4 py-4">
      <div className="flex justify-center pb-2 mb-6 w-52">
        <Logo />
      </div>

      {role === Role.AdPartner && (
        <NavLink to="/client/wallet">
          <div className="flex justify-center pb-2 mb-6 w-52">
            <Balance />
          </div>
        </NavLink>
      )}
      <ul className="flex flex-col">
        {routes[role].map(({ to, Icon, labelKey }) => (
          <NavLink key={to} to={to} end className="mb-1">
            {({ isActive }) => (
              <SidebarButton
                active={isActive}
                fullWidth
                startIcon={
                  <Icon
                    style={{ fontSize: 30, marginRight: 5 }}
                    className={cx({
                      'text-gray-700': !isActive,
                      'text-primary-700': isActive,
                    })}
                  />
                }
              >
                <h2
                  className={cx('text-base font-medium', {
                    'text-gray-700': !isActive,
                    'text-primary-700': isActive,
                  })}
                >
                  <Trans i18nKey={labelKey} />
                </h2>
              </SidebarButton>
            )}
          </NavLink>
        ))}
      </ul>
    </nav>
  );
};
